module.exports = __webpack_public_path__ + "static/media/placeholder12.d0ce9680.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/placeholder12.jpg
// module id = 634
// module chunks = 0